import styled from "styled-components";

// components
import Heading from "core/Heading";
import Flexbox from "core/Flexbox";

// helpers
import { A, BorderBottomLinkStyle } from "core/Typography";
import { convertPxToRem } from "frontend/components/helpers";
import { handleBottomSpacing, handleTopSpacing } from "helpers/spacingAndFonts";

export const Container = styled(Flexbox).attrs({
    flexDirection: "row",
    alignItems: "center"
})`
    ${handleBottomSpacing({ bottomSpacing: "xl" })};
`;

export const StyledA = styled(A)`
    ${BorderBottomLinkStyle}
`;

export const Avatar = styled.img`
    border-radius: 50%;
    width: ${convertPxToRem({ px: 30 })};
    height: ${convertPxToRem({ px: 30 })};
`;

export const InfoHeading = styled(Heading).attrs({
    type: "h2",
    size: "xs"
})`
    margin-left: ${convertPxToRem({ px: 8 })};
`;

export const ButtonContainer = styled.div`
    ${handleTopSpacing({ topSpacing: "2xl" })}
    text-align: center;
`;
